export const spanishCountries = [
  'ES',
  'AR',
  'BO',
  'BR',
  'CL',
  'CO',
  'CR',
  'CU',
  'EC',
  'SV',
  'GF',
  'GD',
  'GT',
  'HT',
  'HN',
  'JM',
  'MX',
  'NI',
  'PY',
  'PA',
  'PE',
  'PR',
  'DO',
  'SR',
  'UY',
  'VE',
];
